"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = void 0;
const util_1 = require("util");
exports.sleep = util_1.promisify(setTimeout);
//# sourceMappingURL=sleep.js.map